import get from 'lodash/get';

// Constants
import { PUBLIC_URL } from '../constants/app'


export function getCustomers(payment) {
  let
    invoices = get(payment, 'invoices'),
    customers = null;

  function getName(obj) {
    let name = get(obj, 'customer.name');
    let legal_name = get(obj, 'customer.legal_name');
    let tax_profile = get(obj, 'customer.tax_profile');

    if (!name) name = legal_name;
    if (!name) name = tax_profile;

    return name;

  } // Get name

  if (Array.isArray(invoices)) {

    if (invoices.length === 0) customers = `Pago sin factura`
    else if (invoices.length === 1) customers = getName(invoices[0]);
    else if (invoices.length > 1) customers = getName(invoices[0]);
    //else if (invoices.length > 1) customers = `${getName(invoices[0])} (${invoices.length} facturas)`;

  } // END if

  return customers ? customers : `Sin datos`;

} // END getCustomers



export function getCurrentEnv(){
  const { href } = window.location;
  let retVal = false;

  if (href.indexOf('localhost') !== -1)                       return retVal = 'local';
  if (href.indexOf('https://app.porcobrar.com') !== -1)       return retVal = 'production';
  if (href.indexOf('https://dev.app.porcobrar.com') !== -1)   return retVal = 'development';
  if (href.indexOf('https://stage.app.porcobrar.com') !== -1) return retVal = 'staging';

  return retVal;

} // END getCurrentEnv



export function isPublicRoute(){
  const publicRoutes = [`/portal/`, '/checkout/'];
  let retVal = publicRoutes.some(value => window.location.href.indexOf(`${PUBLIC_URL}${value}`) !== -1);
  return retVal;

} // END isPublicRoute

export function pricingRoute(pathname = '') {
  if(pathname.includes('app')) return 'app';
  if(pathname.includes('pricing')) return 'pricing';

} // END pricingRoute


// WEBPACK FOOTER //
// ./src/libs/helpers.js